import { create } from "zustand"
import type { Subject } from "@/modules/study/entities/activities"

interface ActivitiesFilterState {
  filteredSubjects: Subject[]
  setFilteredSubjects: (filteredSubjects: Subject[]) => void
}

export const useActivitiesFilter = create<ActivitiesFilterState>((set) => ({
  filteredSubjects: [],
  setFilteredSubjects: (filteredSubjects) =>
    set(() => ({
      filteredSubjects,
    })),
}))

export default useActivitiesFilter.getState()
